import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

const smogBuddyTheme = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#D8FEF8",
            100: "#B5FCF2",
            200: "#66FAE4",
            300: "#1CF7D6",
            400: "#07C0A4",
            500: "#047464",
            600: "#035E50",
            700: "#02453B",
            800: "#022C26",
            900: "#011915",
            950: "#000A08"
        }
    }
});

export default smogBuddyTheme;